import { Col } from "reactstrap";
import { P, Ribbon } from "../../../../AbstractElements";
import { CssRibbons, RibbinLeftText1, RibbinLeftText2, RibbinLeftTextEm } from "../../../../Constant";

export const StaticLeftRibbons = () => {
  return (
    <Col sm="6" xl="4">
      <div className="ribbon-wrapper border border-1 height-equal alert-light-light">
        <Ribbon className="ribbon ribbon-primary ribbon-space-bottom">SAVE 10%</Ribbon>
        <P className="txt-dark">
          <em className="txt-danger">{RibbinLeftTextEm}</em>{RibbinLeftText1}<em className="txt-danger">{CssRibbons}</em>{RibbinLeftText2}
        </P>
      </div>
    </Col>
  );
};
